import { Loader2, Upload } from 'lucide-react';

import { CommandItem } from '@/components/ui/command';
import { type Sandbox } from '@/models/sandbox';

import { useExportSandbox } from '../api/exportSandbox';

interface SandboxExportItemProps {
  /** Unknown while the Sandbox list loads: the item stays disabled until then. */
  sandbox?: Sandbox;
  onExported: () => void;
}

/** Downloads the Sandbox as JSON; owns its request so the menu around it only lists actions. */
export const SandboxExportItem = ({
  sandbox,
  onExported,
}: SandboxExportItemProps) => {
  const exportMutation = useExportSandbox({
    mutationConfig: { onSuccess: onExported },
  });

  return (
    <CommandItem
      disabled={!sandbox || exportMutation.isPending}
      onSelect={() => {
        if (sandbox) exportMutation.mutate({ sandboxId: sandbox.id });
      }}
    >
      {exportMutation.isPending ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Upload className="mr-2 h-4 w-4" />
      )}
      Export Sandbox
    </CommandItem>
  );
};
